import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BoardStatus } from 'app/trello/models/board-status';
import { RequestErrorThrower } from 'app/trello/services/request-error-thrower';
import { TokenService } from 'app/trello/services/token.service';
import { environment } from 'environments/environment';
import { catchError, Observable, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BoardStatusFetcher {

  constructor(
    private readonly http: HttpClient,
    private readonly requestErrorThrower: RequestErrorThrower,
    private readonly tokenService: TokenService,
  ) {
  }

  public fetch(): Observable<BoardStatus> {

    const url = `${environment.apiRoot}${environment.endpoints.boardStatus}`;

    return this.tokenService.userToken
      .pipe(
        take(1),
        switchMap((userToken) =>

          this.http.get<BoardStatus>(
            url,
            {headers: {Authorization: `Bearer ${userToken}`}},
          ),
        ),
        catchError((error: any) => {

          console.error('An error occurred fetching board status:', error);

          return this.requestErrorThrower.throwError(error);
        }),
      );
  }

}
